import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL, OPEN_INFO_API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { AllocationDriverViewProfile, AllocationViewFilterProfileModel, AllocationViewProfile } from '../models';
import { AllocationViewProfilesEndpoint } from '../constants';
import { AllocationViewFiltersModel } from '../../allocation-view/models';

@Injectable({ providedIn: 'root' })
export class AllocationViewProfileItemService {
  constructor(private http: WrapperHttpService) {}

  getProfile(id: number): Observable<AllocationViewProfile> {
    const url = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Profile}/${id}`;
    return this.http.withLoading().get<AllocationViewProfile>(url);
  }

  getDefaultProfile(): Observable<AllocationViewProfile> {
    const url = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Profile}${AllocationViewProfilesEndpoint.Default}`;
    return this.http.withLoading().get<AllocationViewProfile>(url);
  }

  getFilterProfile(id: number): Observable<AllocationViewFilterProfileModel> {
    const profileFilterUrl = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Filters}${AllocationViewProfilesEndpoint.Profiles}/${id}`;
    return this.http.withLoading().get<AllocationViewFilterProfileModel>(profileFilterUrl);
  }

  saveProfile(profile: AllocationViewProfile): Observable<AllocationViewProfile> {
    const url = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Profile}`;
    return this.http.withLoading().post<AllocationViewProfile>(url, profile);
  }

  createOrUpdateFilterProfile(
    name: string,
    id: number,
    filters: AllocationViewFiltersModel,
  ): Observable<AllocationViewFilterProfileModel> {
    const profileFilterUrl = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Filters}${AllocationViewProfilesEndpoint.Profiles}`;
    if (id) {
      return this.http.withLoading().put(profileFilterUrl, { name, id, filters });
    }
    return this.http.withLoading().post(profileFilterUrl, { name, filters });
  }

  deleteProfile(id: number): Observable<AllocationViewProfile> {
    const url = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Profile}/${id}`;
    return this.http.withLoading().delete<AllocationViewProfile>(url);
  }

  deleteFilterProfile(id: number): Observable<AllocationViewFilterProfileModel> {
    const profileFilterUrl = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Filters}${AllocationViewProfilesEndpoint.Profiles}`;
    return this.http.withLoading().delete(`${profileFilterUrl}/${id}`);
  }

  getDriverViewProfile(id: number): Observable<AllocationDriverViewProfile> {
    const url = `${OPEN_INFO_API_URL}${AllocationViewProfilesEndpoint.DriverView}${AllocationViewProfilesEndpoint.Profile}/${id}`;
    return this.http.withLoading().get<AllocationDriverViewProfile>(url);
  }
}
